import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getDispatchNotes = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/dispatch-note/`, body);
        return response.data.data;
    } catch (error) {
        console.log("getDispatchNotes - error", error)
        return handleApiError(error)
    }
}

export const getDispatchNoteById = async (dispatchNoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/dispatch-note/${dispatchNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getDispatchNoteById - error", error)
        return handleApiError(error)
    }
}

export const insertDispatchNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/dispatch-note/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertDispatchNote - error", error)
        return handleApiError(error)
    }
}

export const updateDispatchNote = async (dispatchNoteId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/dispatch-note/update/${dispatchNoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateDispatchNote - error", error)
        return handleApiError(error)
    }
}

export const deleteDispatchNote = async (dispatchNoteId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/dispatch-note/delete/${dispatchNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("deleteDispatchNote - error", error)
        return handleApiError(error)
    }
}


export const getDispatchNoteBySellerPOId = async (sellerPOId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/dispatch-note/seller-po/${sellerPOId}`);
        return await response.data;
    } catch (error) {
        console.log("getDispatchNoteBySellerPOId - error", error)
        return handleApiError(error)
    }
}


export const getDispatchNotesByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/dispatch-note/buyerReqIds`, data);
        return response.data;
    } catch (error) {
        console.log("getDispatchNotesByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}